import React, { useState } from "react";
import { NewHymn } from "./pages/pray/NewHymn";
import { HYMNS } from "./pages/pray/hymns";

export const HymnEditor: React.FC<{}> = () => {
    const [hymnText, setHymnText] = useState("");
    const [tune, setTune] = useState("");

    console.log(
        ">>",
        HYMNS["thirty-years-among-us-dwelling"].text
            .map((line) => {
                return line
                    .map((word) => {
                        return word.join("_");
                    })
                    .join(" ");
            })
            .join("\n")
    );

    return (
        <div style={{ height: "100%", overflow: "auto" }}>
            <div>
                <button
                    onClick={async () => {
                        const blobText = await navigator.clipboard.readText();

                        setTune(
                            blobText
                                .replace(/\).*?\(/g, " ")
                                .replace(/^\(/g, "")
                                .replace(/\)$/g, "")
                                .replace(/'/g, "")
                                .replace(/ /, "\n")
                                .replace(/: /g, ":\n")
                                .replace(/; /g, ";\n")
                                .replace(/, /g, ",\n")
                        );
                    }}
                >
                    Paste tune
                </button>
            </div>
            <textarea
                onChange={(event) => {
                    setTune(event.currentTarget.value);
                }}
                style={{ height: 200, width: 534 }}
                value={tune}
            />
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ paddingTop: 1, paddingRight: 4 }}>
                    {hymnText.split("\n").map((line) => {
                        return (
                            <div
                                style={{
                                    height: 20,
                                    width: 30,
                                    textAlign: "right",
                                    fontWeight: "bold",
                                }}
                            >
                                {line.length === 0
                                    ? ""
                                    : line.replace(/ /g, "_").split("_").length}
                            </div>
                        );
                    })}
                </div>
                <textarea
                    onChange={(event) => {
                        setHymnText(event.currentTarget.value);
                    }}
                    style={{ height: 5000, width: 500, lineHeight: "20px" }}
                >
                    {hymnText}
                </textarea>
                <div style={{ width: 500 }}>
                    <NewHymn
                        hymn={{ text: hymnText, tune, mode: 1, title: "" }}
                    />
                </div>
            </div>
        </div>
    );
};
